import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../../i18n";
import { Logo } from "./Navbar";

export default function Footer() {
  const { t } = useI18n();
  return (
    <footer className="gc-gradient-navy text-white mt-24">
      <div className="max-w-7xl mx-auto px-6 py-14">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <Logo light />
            <p className="mt-4 text-white/60 max-w-sm text-sm leading-relaxed">{t("positioning")}</p>
            <p className="mt-3 text-[hsl(41_72%_60%)] text-sm font-medium">{t("secondary_pos")}</p>
          </div>
          <div>
            <div className="text-xs uppercase tracking-[0.15em] text-white/40 mb-4">{t("nav_compliance")}</div>
            <ul className="space-y-2 text-sm text-white/70">
              <li><Link to="/vat-health-check" className="hover:text-white">{t("nav_health")}</Link></li>
              <li><Link to="/vat-advisory" className="hover:text-white">{t("nav_advisory")}</Link></li>
              <li><Link to="/zatca-audit" className="hover:text-white">{t("nav_zatca")}</Link></li>
              <li><Link to="/pricing" className="hover:text-white">{t("nav_pricing")}</Link></li>
            </ul>
          </div>
          <div>
            <div className="text-xs uppercase tracking-[0.15em] text-white/40 mb-4">Growth Curve</div>
            <ul className="space-y-2 text-sm text-white/70">
              <li><Link to="/about" className="hover:text-white">{t("nav_about")}</Link></li>
              <li><Link to="/knowledge" className="hover:text-white">{t("nav_knowledge")}</Link></li>
              <li><Link to="/contact" className="hover:text-white">{t("nav_contact")}</Link></li>
              <li><Link to="/login" className="hover:text-white">{t("login")}</Link></li>
            </ul>
          </div>
        </div>
        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row justify-between gap-3 text-xs text-white/50">
          <span>{t("footer_copy")}</span>
          <span>VATRdar — {t("brand_sub")}</span>
        </div>
      </div>
    </footer>
  );
}
